import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input, Select, Textarea } from '../../../../components/base/index';
import { Link } from 'react-router-dom';

export default function UploadNilaiTable(props) {
  const { onFormChange, form } = props;
  return (
    <div className="upload-nilai__content">
                <div className="upload-nilai__header">
                  

                </div>
                <div className="upload-nilai__body">
                  <table className="upload-nilai__table">
                    <thead>
                      <tr>
                        <th>Nama Guru</th>
                        <th>Program Tahunan</th>
                        <th>Program Semester</th>
                        <th>Silabus</th>
                        <th>RPP</th>
                        <th>Perangkat pembelajaran Lain</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      {/* {
                      map(journal.details, (list, idx) => (
                        <tr key={`journal_detail_${idx}`}>
                          <td>{idx + 1}</td>
                          <td>{list.code_of_account}</td>
                          <td>{list.parameter_code.title}</td>
                          <td>{list.description}</td>
                          <td className="nominal">{commaFormatted(list.amount)}</td>
                        </tr>
                      ))
                    } */}
                    <tr>
                        <td>Bahasa Indonesia</td>
                        <td><Link to={'/dashboard/kurikulum'}>1</Link> 
                        </td>
                        <td><Link to={'/dashboard/kurikulum'}>1</Link> 
                        </td>
                        <td><Link to={'/dashboard/kurikulum'}>1</Link> 
                        </td>
                        <td><Link to={'/dashboard/kurikulum'}>1</Link> 
                        </td>
                        <td><Link to={'/dashboard/kurikulum'}>1</Link> 
                        </td>
                       

                    </tr>
                   
                    </tbody>
                    {/* <tfoot>
                      <tr>
                        <td colSpan="1" className="nominal">Catatan Wali Kelas</td>
                        <td colSpan="8" className="nominal"></td>
                      </tr>
                    </tfoot> */}
                  </table>
                </div>
              </div>
  );
}
UploadNilaiTable.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
UploadNilaiTable.defaultProps = {
  onFormChange: noop,
};
